export default {
    name: "customer-details-form",
    props: ["instanceId"],
    emits: ["canContinue"],
    data() {
        return {
            timenow: new Date(),
            dateOfBirth: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            dateFormat: "dd/MM/yyyy",
            sites: [],
            selectedSiteId: 0,
            attendantNumber: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            cardBarcode: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            genderId: -1,
            emailAddress: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            acceptPromotionalOffers: false,
            residentialAddress:{
                street: null,
                suburb: null,
                city: null,
                province: null,
                postalCode: null
            },
            loading: false
        };
    },
    methods: {
        getSites(){
            systemService.getSites().then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        //success
                        console.log("success", successResponse);
                        this.sites = successResponse.data.result;
                        this.sites = $.map(this.sites,
                            function (obj) {
                                obj.id = obj.id || obj.siteId;
                                obj.text = obj.text || obj.name;
                                return obj;
                            });
                        if(this.sites !== null && this.sites !== undefined && this.sites.length > 0){
                            this.selectedSiteId = this.sites[0].id;
                        }
                    }
                },
                errorResponse => {
                    //error
                    console.log("error", errorResponse);
                    //apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
        onSiteDropdownChange(site){
            console.log("Site dropdown change");
            console.log(site);
            this.selectedSiteId = site.id;
        },
        validateForm(){
            this.saveCustomerDetails();
        },
        saveCustomerDetails(){
            this.loading = true;
            console.log("this.selectedSiteId", this.selectedSiteId);
            let request = {
                attendantName: this.attendantNumber.value,
                cardBarcodeNumber: this.cardBarcode.value,
                dateOfBirth: this.dateOfBirth.value,
                genderId: this.genderId,
                acceptPromotionalOffers: this.acceptPromotionalOffers,
                emailAddress: this.emailAddress.value,
                streetAddress: this.residentialAddress.street,
                suburb: this.residentialAddress.suburb,
                city: this.residentialAddress.city,
                province: this.residentialAddress.province,
                postalCode: this.residentialAddress.postalCode,
                instanceId: this.instanceId,
                siteId: this.selectedSiteId
            };
            customerService.addNewCustomer(request).then(
                response => {
                    if (response.status === 400){
                        // show validation errors
                        this.emailAddress.hasError = response.data.customerSignUpValidationStepCustomerDetailsResponse.emailAddressValidationResponse.hasError;
                        this.emailAddress.errorMessage = response.data.customerSignUpValidationStepCustomerDetailsResponse.emailAddressValidationResponse.message;
                        
                        this.attendantNumber.hasError = response.data.customerSignUpValidationStepCustomerDetailsResponse.attendantNumberValidationResponse.hasError;
                        this.attendantNumber.errorMessage = response.data.customerSignUpValidationStepCustomerDetailsResponse.attendantNumberValidationResponse.message;
                        // this.dateOfBirth.hasError = response.data.customerSignUpValidationStepCustomerDetailsResponse.dateOfBirthValidationResponse.hasError;
                        // this.dateOfBirth.errorMessage = response.data.customerSignUpValidationStepCustomerDetailsResponse.dateOfBirthValidationResponse.message;
                        
                        this.cardBarcode.hasError = response.data.customerSignUpValidationStepCustomerDetailsResponse.cardBarcodeValidationResponse.hasError;
                        this.cardBarcode.errorMessage = response.data.customerSignUpValidationStepCustomerDetailsResponse.cardBarcodeValidationResponse.message;
                        
                        if(response.data.validationResult !== null){
                            if(response.data.validationResult.emailDoesNotExist === false){
                                this.emailAddress.errorMessage = "Email already exists";
                                this.emailAddress.hasError = true;
                            }
                        }
                        
                        this.$emit("canContinue", {
                            canContinue: false,
                            instanceId: this.instanceId
                        });
                    }
                    if (response.status === 200){
                        this.$emit("canContinue", {
                            canContinue: true,
                            instanceId: this.instanceId
                        });
                    }
                    this.loading = false;
                });
        }
    },
    mounted: function () {
        this.getSites();
    }
};